// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Modal-Dialog-module--dialog--7BlNL","fill":"Modal-Dialog-module--fill--3jY7g","center":"Modal-Dialog-module--center--6OnXI"};